import React, { useRef } from 'react';
import L from 'leaflet';
import { Route, RenderMode } from '../../types/index';
import { ActivityKey } from '../routes/RouteTooltip';
import { useMap } from '../../hooks/useMap';
import { useMapLayers } from '../../hooks/useMapLayers';
import { useMapMarkers } from '../../hooks/useMapMarkers';

// Configuration des icônes Leaflet
delete (L.Icon.Default.prototype as any)._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-icon-2x.png',
  iconUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-icon.png',
  shadowUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-shadow.png',
});

interface MapContainerProps {
  routes: Route[];
  allRoutes: Route[];
  renderMode: RenderMode;
  showRanges: boolean;
  selectedActivity?: ActivityKey;
}

export const MapContainer: React.FC<MapContainerProps> = ({
  routes,
  allRoutes,
  renderMode,
  showRanges,
  selectedActivity,
}) => {
  const mapRef = useRef<HTMLDivElement>(null);
  const mapInstance = useMap(mapRef);
  
  useMapLayers(mapInstance, showRanges, selectedActivity);
  useMapMarkers(mapInstance, allRoutes, routes, selectedActivity);

  return (
    <div
      ref={mapRef}
      style={{ height: '100%', width: '100%', minHeight: '400px', backgroundColor: '#f0f0f0' }}
    />
  );
};

export default MapContainer;
